import { render, staticRenderFns } from "./CambiarTipo.vue?vue&type=template&id=f7797602&"
import script from "./CambiarTipo.vue?vue&type=script&lang=js&"
export * from "./CambiarTipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports